import { render, staticRenderFns } from "./ButtonPage.vue?vue&type=template&id=77b26d16&scoped=true&"
import script from "./ButtonPage.vue?vue&type=script&lang=js&"
export * from "./ButtonPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b26d16",
  null
  
)

export default component.exports